module.exports = __webpack_public_path__ + "static/productos@2xl-cb163d4957f2a7d12eecb3844ad6a6ef.png";